import type { ComponentType } from 'react';
import type { ComplexStageKey } from '../api/complexServicesFunctions';
import ComplexServicesMrr from '../stages/ComplexServicesMrr';
import ComplexServicesIgd from '../stages/ComplexServicesIgd';
import ComplexServicesForm9 from '../stages/ComplexServicesForm9';

/**
 * Durable acquisition-package stages with backend foundation routes. Keeping
 * their shared props contract here lets App hydrate and dispatch each fixed
 * step through one conventional component registry.
 */
export const COMPLEX_SERVICES_ARTIFACT_STAGE_KEYS = [
  'mrr',
  'igd',
  'form9',
] as const;

export type ComplexServicesArtifactStageKey =
  (typeof COMPLEX_SERVICES_ARTIFACT_STAGE_KEYS)[number];

export interface ComplexServicesArtifactStageProps {
  flowId?: string | null;
  initialData?: unknown;
  onComplete: (data?: unknown) => void;
}

export type ComplexServicesArtifactStageComponent = ComponentType<
  ComplexServicesArtifactStageProps
>;

/**
 * App renders a registered conventional component when one already exists.
 * The registry remains the integration seam for future artifact stages without
 * creating component bodies in this wiring layer.
 */
export const COMPLEX_SERVICES_ARTIFACT_STAGE_COMPONENTS: Partial<
  Record<ComplexServicesArtifactStageKey, ComplexServicesArtifactStageComponent>
> = {
  mrr: ComplexServicesMrr,
  igd: ComplexServicesIgd,
  form9: ComplexServicesForm9,
};

export function isComplexServicesArtifactStage(
  key: ComplexStageKey,
): key is ComplexServicesArtifactStageKey {
  return (COMPLEX_SERVICES_ARTIFACT_STAGE_KEYS as readonly string[]).includes(key);
}
